import React, { Component } from 'react';
import './App.css';
import Peinture from './Peinture.js'
import Video from './Video.js'

export default class Tiles extends Component {
    
    render() {
        const listItems = [];
        
        const id = parseInt(this.props.periode) - 1;
        this.props.liste[id].peintures.forEach(peinture => {
            listItems.push(
                <Peinture peinture={peinture} />
            );
        }
        );

    return (
        <div>

<div className="titre">Galeries (sélèction d'œuvres caractéristiques) : {this.props.liste[id].libelle}</div>
  
        <span class="presentation">"{this.props.liste[id].description}"</span>
        <br />
        <br />
            <Video video={this.props.liste[id].video} />
    <div class="card-columns">
        {listItems}
    </div>
</div>
    );
}
}



// WEBPACK FOOTER //
// ./src/Tiles.js